import {MdReportGmailerrorred} from "react-icons/md";

const TosanAccessDenied=()=>{

    return  <div className="w-full flex  min-h-screen flex-col  items-center justify-center">
        <MdReportGmailerrorred className="text-5xl text-red-500 "/>
        <div className="w-11/12 flex justify-center items-center flex-col lg:w-4/12">
            <h1 className="text-xl mt-4 text-red-500 font-bold">خطای دسترسی</h1>
            <p className="text-sm mt-3 ">دسترسی شما منقضی شده است </p>
        </div>
    </div>
}
export default TosanAccessDenied;